import { useFilters } from '../../contexts/filters/FiltersContext';

/**
 * True while FiltersContext hydrates: chat type / period come from the account, and range stays
 * null until GET /monitor/prompt/date-range responds (also re-nulled on a project switch). Disabled
 * queries report isLoading=false in that window, so pages must OR this into their loading props —
 * otherwise sections flash "no data" instead of skeletons before the first real fetch even starts.
 */
const useFiltersInitializing = (): boolean => {
  const { selectedChatType, monitorPeriod, range } = useFilters();
  return !selectedChatType || !monitorPeriod || !range?.[0] || !range?.[1];
};

export default useFiltersInitializing;
